import { styled } from '@mui/material';

const PREFIX = 'CompGroupsOptions';

export const compGroupsOptionsClasses = {
  paper: `${PREFIX}-paper`,
  menuList: `${PREFIX}-menuList`,
  menuItem: `${PREFIX}-menuItem`,
};

export const CompGroupsOptionsRoot = styled('div')(() => ({
  position: 'absolute',
  right: 0,
  top: 0,
  [`& .${compGroupsOptionsClasses.paper}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },

  [`& .${compGroupsOptionsClasses.menuList}`]: {
    '& .MuiListItem-root': {
      textAlign: 'right',
      justifyContent: 'end',
      width: 'fit-content',
    },
    '& .MuiMenuItem-root': {
      marginLeft: 'auto',
      backgroundColor: '#037DE8',
      color: '#FFFFFF',
      margin: '0.8rem 0',
      borderRadius: '2.688rem',
      textTransform: 'uppercase',
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: '#043A6E',
    },
  },

  [`& .${compGroupsOptionsClasses.menuItem}`]: {},
}));